import './app.css'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import LoginPage from './pages/login/login-page'
import HomePage from './pages/home-page'
import StampsPage from './pages/equipment/stamps/stamps-page'
import LabelPrintingPage from './pages/equipment/stamps/pages/label-printing/label-printing-page'
import { dynamicRoutes, routes } from './constants/routes'
import StampOrdersPage from './pages/purchases/stamp-orders/stamp-orders-page'
import StampPage from './pages/equipment/stamps/pages/stamp/stamp-page'
import StampOrderPage from './pages/purchases/stamp-orders/pages/stamp-order/stamp-order-page'
import qs from 'qs'
import styled, { ThemeProvider } from 'styled-components'
import RollersPage from './pages/equipment/rollers/rollers-page'
import EquipmentFlexoFormsPage from './pages/equipment/flexo-forms/flexo-forms-page'
import StampWriteOffsPage from './pages/write-offs/stamp-write-offs/stamp-write-offs-page'
import PrivateSection from './components/private-section/private-section'
import BalancesMaterialsPage from './pages/balances/materials/materials-page'
import StampMainPage from './pages/stamp-main/stamp-main-page'
import CalculationsPage from './pages/calculations/calculations-page'
import RibbonsPage from './pages/ribbons/ribbons-page'
import PaintsPage from './pages/paints/paints-page'
import OrdersPage from './pages/orders/orders-page'
import MaterialOrdersPage from './pages/purchases/material-orders/material-orders-page'
import MaterialOrderRequestsPage from './pages/purchases/material-order-requests/material-order-requests-page'
import FlexoPage from './pages/schedules/flexo/flexo-page'
import RewindPage from './pages/schedules/rewind/rewind-page'
import ShipmentsPage from './pages/shipments/shipments-page'
import DesignerTasksPage from './pages/designer-tasks/designer-tasks-page'
import DesignerTasksOvertimePage from './pages/designer-tasks/overtime/overtime-page'
import CuratorTasksPage from './pages/curator-tasks/curator-tasks-page'
import CorrectorTasksPage from './pages/corrector-tasks/corrector-tasks-page'
import BlankPage from './pages/templates/blank-page'
import MaterialsPageOld from './pages/receipts/materials-old/materials-page-old'
import MaterialsPage from './pages/receipts/materials/material-page'
import { theme } from 'antd'
import MachinesSchedulePage from './pages/machines-schedule/machines-schedule-page'
import RewinderMachinesSchedulePage from './pages/rewinder-machines-schedule/rewinder-machines-schedule-page'
import PrintPreparationPage from './pages/print-preparation/print-preparation-page'
import ConsumptionPage from './pages/consumption/consumption-page'
import TechnicalCardsPage from './pages/technical-cards/technical-cards-page'
import PrintHistoryPage from './pages/print-history/print-history-page'
import VolumeSummaryPage from './pages/volume-summary/volume-summary-page'
import RewindHistoryPage from './pages/rewind-history/rewind-history-page'
import CompletedPrintJobsPage from './pages/completed-print-jobs/completed-print-jobs-page'
import DevPage from './pages/dev/dev'
import ClientsPage from './pages/clients/clients-page'
import ClientAddPage from './pages/clients/add/add-page'
import ClientEditPage from './pages/clients/edit/edit-page'
import FlexoFormsPage from './pages/receipts/flexo-forms/flexo-forms-page'
import ShiftsPage from './pages/schedules/shifts/shifts-page'
import ProfilePage from './pages/profile/profile-page'
import { MessageBar } from './components/message-bar/message-bar'

window.qs = qs

const AppStyled = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    min-height: 0;

    .ant-input-number {
        width: 100%;
    }

    .ant-picker {
        width: 100%;
    }
`

const Pages = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
`

const RedirectToRoute = ({ route }: { route: string }) => {
    const location = useLocation()

    return <Navigate to={`${route}${location.search}`} replace />
}

function App() {
    const { token } = theme.useToken()

    return (
        <ThemeProvider theme={token}>
            <AppStyled>
                <MessageBar />
                <Pages>
                <Routes>
                    <Route path={routes.login} element={<LoginPage />} />
                    <Route
                        path={routes.dev}
                        element={
                            <PrivateSection>
                                <DevPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.clients}
                        element={
                            <PrivateSection route={routes.clients}>
                                <ClientsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.clientsAdd}
                        element={
                            <PrivateSection route={routes.clientsAdd}>
                                <ClientAddPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.clientsEdit}
                        element={
                            <PrivateSection route={routes.clientsEdit}>
                                <ClientEditPage />
                            </PrivateSection>
                        }
                    />

                    <Route
                        path={routes.home}
                        element={
                            <PrivateSection>
                                <HomePage />
                            </PrivateSection>
                        }
                    />

                    <Route
                        path={routes.equipmentStamps}
                        element={
                            <PrivateSection>
                                <StampsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.equipmentStamp}
                        element={
                            <PrivateSection>
                                <StampPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.equipmentStampsLabelPrinting}
                        element={
                            <PrivateSection>
                                <LabelPrintingPage />
                            </PrivateSection>
                        }
                    />

                    <Route
                        path={routes.equipmentRollers}
                        element={
                            <PrivateSection>
                                <RollersPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.equipmentFlexoForms}
                        element={
                            <PrivateSection route={routes.equipmentFlexoForms}>
                                <EquipmentFlexoFormsPage />
                            </PrivateSection>
                        }
                    />

                    <Route
                        path={routes.purchasesStampOrders}
                        element={<RedirectToRoute route={dynamicRoutes.purchasesStampOrdersTab('created')} />}
                    />
                    <Route
                        path={routes.purchasesStampOrdersCreated}
                        element={
                            <PrivateSection>
                                <StampOrdersPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.purchasesStampOrdersProcessed}
                        element={
                            <PrivateSection>
                                <StampOrdersPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.purchasesStampOrder}
                        element={
                            <PrivateSection>
                                <StampOrderPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.purchasesMaterialOrders}
                        element={
                            <RedirectToRoute
                                route={dynamicRoutes.purchasesMaterialOrdersTab('requests')}
                            />
                        }
                    />
                    <Route
                        path={routes.purchasesMaterialOrdersTab}
                        element={
                            <PrivateSection route={routes.purchasesMaterialOrders}>
                                <MaterialOrdersPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.purchasesMaterialOrderRequests}
                        element={
                            <PrivateSection route={routes.purchasesMaterialOrderRequests}>
                                <MaterialOrderRequestsPage />
                            </PrivateSection>
                        }
                    />

                    <Route
                        path={routes.writeOffsStampWriteOffs}
                        element={
                            <PrivateSection>
                                <StampWriteOffsPage />
                            </PrivateSection>
                        }
                    />

                    <Route
                        path={routes.receiptsMaterialsOld}
                        element={
                            <PrivateSection>
                                <MaterialsPageOld />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.receiptsMaterials}
                        element={
                            <RedirectToRoute route={dynamicRoutes.receiptsMaterialsTab('expected')} />
                        }
                    />
                    <Route
                        path={routes.receiptsMaterialsTab}
                        element={
                            <PrivateSection>
                                <MaterialsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.receiptsFlexoForms}
                        element={
                            <RedirectToRoute route={dynamicRoutes.receiptsFlexoFormsTab('expected')} />
                        }
                    />
                    <Route
                        path={routes.receiptsFlexoFormsTab}
                        element={
                            <PrivateSection route={routes.receiptsFlexoForms}>
                                <FlexoFormsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.balancesMaterials}
                        element={
                            <PrivateSection route={routes.balancesMaterials}>
                                <BalancesMaterialsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.stampMainPage}
                        element={
                            <PrivateSection route={routes.stampMainPage}>
                                <StampMainPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.calculations}
                        element={
                            <PrivateSection route={routes.calculations}>
                                <CalculationsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.ribbons}
                        element={
                            <PrivateSection route={routes.ribbons}>
                                <RibbonsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.paints}
                        element={
                            <PrivateSection route={routes.paints}>
                                <PaintsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.orders}
                        element={
                            <PrivateSection route={routes.orders}>
                                <OrdersPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.shipments}
                        element={
                            <PrivateSection route={routes.shipments}>
                                <ShipmentsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.schedulesFlexo}
                        element={<RedirectToRoute route={dynamicRoutes.schedulesFlexoTab('flexo')} />}
                    />
                    <Route
                        path={routes.schedulesFlexoTab}
                        element={
                            <PrivateSection route={routes.schedulesFlexo}>
                                <FlexoPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.schedulesFlexoMachines}
                        element={
                            <PrivateSection route={routes.schedulesFlexoMachines}>
                                <MachinesSchedulePage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.shifts}
                        element={
                            <PrivateSection route={routes.shifts}>
                                <ShiftsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.schedulesDigital}
                        element={
                            <PrivateSection route={routes.schedulesDigital}>
                                <RedirectToRoute route={dynamicRoutes.schedulesFlexoTab('digital')} />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.schedulesRewindMachines}
                        element={
                            <PrivateSection route={routes.schedulesRewindMachines}>
                                <RewinderMachinesSchedulePage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.schedulesRewind}
                        element={
                            <PrivateSection route={routes.schedulesRewind}>
                                <RewindPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.designerTasks}
                        element={
                            <PrivateSection route={routes.designerTasks}>
                                <DesignerTasksPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.designerTasksOvertime}
                        element={
                            <PrivateSection route={routes.designerTasksOvertime}>
                                <DesignerTasksOvertimePage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.curatorTasks}
                        element={
                            <PrivateSection route={routes.curatorTasks}>
                                <CuratorTasksPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.correctorTasks}
                        element={
                            <PrivateSection route={routes.correctorTasks}>
                                <CorrectorTasksPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.printPreparation}
                        element={
                            <PrivateSection>
                                <PrintPreparationPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.consumption}
                        element={
                            <PrivateSection>
                                <ConsumptionPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.technicalCards}
                        element={
                            <PrivateSection>
                                <TechnicalCardsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.printHistory}
                        element={
                            <RedirectToRoute route={dynamicRoutes.printHistoryTab('flexo')} />
                        }
                    />
                    <Route
                        path={routes.printHistoryTab}
                        element={
                            <PrivateSection route={routes.printHistory}>
                                <PrintHistoryPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.volumeSummary}
                        element={
                            <PrivateSection route={routes.volumeSummary}>
                                <VolumeSummaryPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.rewindHistory}
                        element={
                            <PrivateSection route={routes.rewindHistory}>
                                <RewindHistoryPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.completedPrintJobs}
                        element={
                            <PrivateSection route={routes.completedPrintJobs}>
                                <CompletedPrintJobsPage />
                            </PrivateSection>
                        }
                    />
                    <Route
                        path={routes.profile}
                        element={
                            <PrivateSection route={routes.profile}>
                                <ProfilePage />
                            </PrivateSection>
                        }
                    />

                    <Route path={routes.templatesBlank} element={<BlankPage />} />
                    {/* TODO: Раскоментить! */}
                    {/* <Route
                        path={routes.templatesBlank}
                        element={
                            <PrivateSection>
                                <BlankPage />
                            </PrivateSection>
                        }
                    /> */}
                </Routes>
                </Pages>
            </AppStyled>
        </ThemeProvider>
    )
}

export default App
